import {
  ActionIcon,
  Burger,
  Group,
  Tooltip,
  useMantineColorScheme,
} from '@mantine/core';
import {
  IconMoonStars,
  IconSunHigh,
} from '@tabler/icons-react';

import { SidebarState } from '@/types';
import { LanguagePicker } from '@/components';
import { SignedIn, UserButton } from '@clerk/clerk-react';
import { dark } from '@clerk/themes';

const ICON_SIZE = 20;

type HeaderNavProps = {
  mobileOpened?: boolean;
  toggleMobile?: () => void;
  sidebarState: SidebarState;
  onSidebarStateChange: (state: SidebarState) => void;
};

const HeaderNav = (props: HeaderNavProps) => {
  const { mobileOpened, onSidebarStateChange } = props;

  // const theme = useMantineTheme();
  const { setColorScheme, colorScheme } = useMantineColorScheme();

  return (
    <Group justify="space-between" h="100%" px="md" pt={8}>
      <Group gap={0}>
        <Tooltip label="Toggle side navigation">
          <Burger
            visibleFrom="md"
            size="sm"
            onClick={() => {
              const nextState =
                props.sidebarState === 'full'
                  ? 'mini'
                  : props.sidebarState === 'mini'
                    ? 'hidden'
                    : 'full';
              onSidebarStateChange(nextState);
            }}
          />
        </Tooltip>
        <Burger
          opened={mobileOpened}
          onClick={() => {
            const nextState =
              props.sidebarState === 'full'
                ? 'hidden'
                : 'full';
            onSidebarStateChange(nextState);
          }}
          hiddenFrom="md"
          size="sm"
        />
      </Group>
      <Group>
        <LanguagePicker type="collapsed" />
        <Tooltip label="Switch color modes">
          <ActionIcon
            variant="light"
            onClick={() =>
              setColorScheme(colorScheme === 'dark' ? 'light' : 'dark')
            }
          >
            {colorScheme === 'dark' ? (
              <IconSunHigh size={ICON_SIZE} />
            ) : (
              <IconMoonStars size={ICON_SIZE} />
            )}
          </ActionIcon>
        </Tooltip>
        <SignedIn>
          <UserButton appearance={colorScheme === 'dark' ? { baseTheme: dark } : {}} />
        </SignedIn>
      </Group>
    </Group>
  );
};

export default HeaderNav;